'use client'
import Link from 'next/link'
import React, { useState } from 'react'

export default function DrivernBusinessSection() {
   const [expanded, setExpanded] = useState(false)

   const toggleView = () => {
      setExpanded((prev) => !prev)
   }

   return (
      <section className="container-fluid section_secondary_bg">
         <div className="container text-center mb-5 innovation_comman">
            <h2 className="tech_title section_heading_title mb-2">
               Smarter Business with AI & ML:
            </h2>
            <h2 className="tech_title section_heading_title mb-2">
               What It Really Means Across Industries
            </h2>
            <p className="tech_body tech_title">
               Pushing Innovation Forward with Advanced AI and Machine Learning
            </p>
            <p className="sub_body">
               At Benzatine, we don’t just build AI/ML solutions — we use them
               to help real businesses make better decisions, automate routine
               work, and stay ahead with smarter insights. Whether it's
               predictive analytics or intelligent workflows, our custom-built
               technologies are designed to meet each industry’s unique
               challenges and help teams work more efficiently.
            </p>
         </div>

         <div className="container text-center">
            <div className="innovation_card_main">
               <div
                  className={`row g-4 ${
                     !expanded ? 'industry-grid' : 'industry-grid-mini-toggled'
                  }`}
               >
                  {/* <!-- Health & Fitness --> */}
                  <div className="col-lg-4 col-md-6 industry-card-wrapper line-before">
                     <Link href="/industries/health-fitness-software-development-solutions">
                        <div className="industry-card">
                           <h3 className="industry-title">Health & Fitness</h3>
                           <div className="icon-circle">
                              <img
                                 src="/assets/svg/technologies/angular/Health.svg"
                                 alt="Health Icon"
                              />
                           </div>
                           <h4 className="industry-subtitle">
                              AI Solutions for Healthcare
                           </h4>
                           <p className="industry-description">
                              In the health sector, we create AI products that
                              support doctors and healthcare personnel in making
                              better patient care decisions, streamlining
                              diagnoses, and automating daily tasks. Added to
                              this is the fact that everything is done with data
                              protection and compliance in mind, keeping your
                              operations safe and regulatory-compliant.
                           </p>
                        </div>
                     </Link>
                  </div>

                  {/* <!-- Fintech --> */}
                  <div className="col-lg-4 col-md-6 industry-card-wrapper line-before">
                     <Link href="/industries/fintech-software-development-solutions">
                        <div className="industry-card">
                           <h3 className="industry-title">Banking & Finance</h3>
                           <div className="icon-circle">
                              <img
                                 src="/assets/svg/technologies/angular/Fintech.svg"
                                 alt="Fintech Icon"
                              />
                           </div>
                           <h4 className="industry-subtitle">
                              AI Solutions for Banking & Finance
                           </h4>
                           <p className="industry-description">
                              We offer AI tools that support financial analysis
                              and fraud prevention, helping institutions make
                              smarter, safer decisions. Our AI/ML solutions
                              enhance risk management, automate transactions,
                              and personalize banking experiences for improved
                              customer satisfaction.
                           </p>
                        </div>
                     </Link>
                  </div>

                  {/* <!-- Restaurant & Hospitality --> */}
                  <div className="col-lg-4 col-md-6 industry-card-wrapper line-before">
                     <Link href="/industries/restaurant-hospitality-software-solutions">
                        <div className="industry-card">
                           <h3 className="industry-title">
                              Restaurants & Hospitality
                           </h3>
                           <div className="icon-circle">
                              <img
                                 src="/assets/svg/technologies/angular/Food.svg"
                                 alt="Restaurant Icon"
                              />
                           </div>
                           <h4 className="industry-subtitle">
                              AI Solutions for Restaurants & Hospitality
                           </h4>
                           <p className="industry-description">
                              From predictive inventory management to AI-based
                              customer service chatbots, our AI/ML development
                              revolutionizes the restaurant industry by making
                              operations more efficient and customer experiences
                              more personal.
                           </p>
                        </div>
                     </Link>
                  </div>

                  {/* <!-- Ecommerce --> */}
                  <div className="col-lg-4 col-md-6 industry-card-wrapper">
                     <Link href="/industries/e-commerce-software-development-solutions">
                        <div className="industry-card">
                           <h3 className="industry-title">
                              Enhanced eCommerce
                           </h3>
                           <div className="icon-circle">
                              <img
                                 src="/assets/svg/technologies/angular/Ecommerce.svg"
                                 alt="Ecommerce Icon"
                              />
                           </div>
                           <h4 className="industry-subtitle">
                              AI Solutions for Enhanced eCommerce
                           </h4>
                           <p className="industry-description">
                              Enhance conversions through AI-driven
                              recommendation engines, AI-powered customer care,
                              and forecast analysis. Benefit from AI/ML
                              eCommerce solutions using our AI-powered eCommerce
                              solutions and personalize customers' shopping
                              experiences, vary prices, and enhance inventory
                              prediction.
                           </p>
                        </div>
                     </Link>
                  </div>

                  {/* <!-- Supply Chain & Logistics --> */}
                  <div className="col-lg-4 col-md-6 industry-card-wrapper">
                     <Link href="/industries/supply-chain-logistics-software-solutions">
                        <div className="industry-card">
                           <h3 className="industry-title">
                              Logistics & Supply Chain
                           </h3>
                           <div className="icon-circle">
                              <img
                                 src="/assets/svg/technologies/angular/Supply.svg"
                                 alt="Logistics Icon"
                              />
                           </div>
                           <h4 className="industry-subtitle">
                              AI Solutions for Logistics & Supply Chain
                           </h4>
                           <p className="industry-description">
                              Improve supply chain effectiveness with route
                              optimization through AI, real-time monitoring, and
                              demand prediction. Our AI/ML models lower
                              operation expenses, reduce delays, and optimize
                              logistics management.
                           </p>
                        </div>
                     </Link>
                  </div>

                  {/* <!-- Social & Dating --> */}
                  <div className="col-lg-4 col-md-6 industry-card-wrapper">
                     <Link href="/industries/social-dating-software-development-solutions">
                        <div className="industry-card">
                           <h3 className="industry-title">Social Networking</h3>
                           <div className="icon-circle">
                              <img
                                 src="/assets/svg/technologies/angular/Social.svg"
                                 alt="Social Icon"
                              />
                           </div>
                           <h4 className="industry-subtitle">
                              AI Solutions for Social Networking
                           </h4>
                           <p className="industry-description">
                              Transform user interaction with AI-based content
                              recommendation, smart chatbots, and deep learning
                              techniques that make users' experiences unique,
                              leading to increased retention levels in social
                              networking sites.
                           </p>
                        </div>
                     </Link>
                  </div>

                  {/* <!-- Gaming & Sports --> */}
                  <div className="col-lg-4 col-md-6 industry-card-wrapper line-before">
                     <Link href="/industries/gaming-sports-software-development-solutions">
                        <div className="industry-card">
                           <h3 className="industry-title">
                              Gaming & Sports Analytics
                           </h3>
                           <div className="icon-circle">
                              <img
                                 src="/assets/svg/technologies/angular/Gaming.svg"
                                 alt="Gaming Icon"
                              />
                           </div>
                           <h4 className="industry-subtitle">
                              AI Solutions for Gaming & Sports Analytics
                           </h4>
                           <p className="industry-description">
                              AI-driven game development, real-time player
                              analytics, and performance tracking revolutionize
                              gaming and sports industries. Our AI/ML solutions
                              improve user experiences and deliver actionable
                              insights for athletes and coaches.
                           </p>
                        </div>
                     </Link>
                  </div>

                  {/* <!-- Travel & Tourism --> */}
                  <div className="col-lg-4 col-md-6 industry-card-wrapper line-before">
                     <Link href="/industries/travel-tourism-software-development-solutions">
                        <div className="industry-card">
                           <h3 className="industry-title">Travel & Tourism</h3>
                           <div className="icon-circle">
                              <img
                                 src="/assets/svg/technologies/angular/travel.svg"
                                 alt="Travel Icon"
                              />
                           </div>
                           <h4 className="industry-subtitle">
                              AI Solutions for Travel & Tourism
                           </h4>
                           <p className="industry-description">
                              From AI-based virtual assistants to smart
                              itinerary management, our AI/ML solutions maximize
                              customer experiences, book ahead, and forecast
                              traveler behavior for seamless service delivery.
                           </p>
                        </div>
                     </Link>
                  </div>

                  {/* <!-- Real Estate --> */}
                  <div className="col-lg-4 col-md-6 industry-card-wrapper line-before">
                     <Link href="/industries/real-estate-software-development-solutions">
                        <div className="industry-card">
                           <h3 className="industry-title">Real Estate</h3>
                           <div className="icon-circle">
                              <img
                                 src="/assets/svg/technologies/angular/Real-Estate.svg"
                                 alt="Real Estate Icon"
                              />
                           </div>
                           <h4 className="industry-subtitle">
                              AI Solutions for Real Estate
                           </h4>
                           <p className="industry-description">
                              Our real estate solutions built on AI include
                              smart property recommendations, market research,
                              and value models that drive informed
                              decision-making for buyers, sellers, and agents.
                           </p>
                        </div>
                     </Link>
                  </div>

                  {/* <!-- Education --> */}
                  <div className="col-lg-4 col-md-6 industry-card-wrapper">
                     <Link href="/industries/education-software-development-solutions">
                        <div className="industry-card">
                           <h3 className="industry-title">
                              Education & E-Learning
                           </h3>
                           <div className="icon-circle">
                              <img
                                 src="/assets/svg/technologies/angular/Edu.svg"
                                 alt="Education Icon"
                              />
                           </div>
                           <h4 className="industry-subtitle">
                              AI Solutions for Education & E-Learning
                           </h4>
                           <p className="industry-description">
                              Reimagine learning with AI-based adaptive
                              education systems, auto-marking, and one-on-one
                              tutoring. Our AI/ML development makes education
                              more accessible, interactive, and efficient.
                           </p>
                        </div>
                     </Link>
                  </div>

                  {/* <!-- Media & Entertainment --> */}
                  <div className="col-lg-4 col-md-6 industry-card-wrapper">
                     <div className="industry-card">
                        <h3 className="industry-title">
                           Media & Entertainment
                        </h3>
                        <div className="icon-circle">
                           <img
                              src="/assets/svg/technologies/angular/Media.svg"
                              alt="Media Icon"
                           />
                        </div>
                        <h4 className="industry-subtitle">
                           AI Solutions for Media & Entertainment
                        </h4>
                        <p className="industry-description">
                           Unlock AI-driven content recommendations, automated
                           video editing, and deep learning-powered audience
                           insights. Our AI/ML solutions enhance media
                           personalization and content creation.
                        </p>
                     </div>
                  </div>

                  {/* <!-- Government & Public Sector --> */}
                  <div className="col-lg-4 col-md-6 industry-card-wrapper">
                     <div className="industry-card">
                        <h3 className="industry-title">
                           Government & Public Sector
                        </h3>
                        <div className="icon-circle">
                           <img
                              src="/assets/svg/technologies/angular/Gov.svg"
                              alt="Government Icon"
                           />
                        </div>
                        <h4 className="industry-subtitle">
                           AI Solutions for Government & Public Sector
                        </h4>
                        <p className="industry-description">
                           Power governance through AI-driven data analytics,
                           AI-enabled citizen services, and forecasted policy
                           decisions. Our AI/ML offerings bring efficiency,
                           security, and evidence-based decision support to the
                           public sector for better, responsive governance.
                        </p>
                     </div>
                  </div>
                  {/* <!-- ... existing code ... --> */}
               </div>
            </div>
            <div className="d-md-none d-inline">
               <div id="showbutton" onClick={toggleView} className="mt-2">
                  {!expanded ? ' Show More' : ' Show Less'}
               </div>
            </div>
            <Link
               href="/discover-benzatine/contact-us"
               className="btn bez-fill-btn mt-4"
            >
               discover your business requirements
               <svg
                  width="37"
                  className="img-fluid"
                  height="37"
                  viewBox="0 0 37 37"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
               >
                  <g clipPath="url(#clip0_5116_214025)">
                     <path
                        d="M36.2699 17.749L28.0882 9.56725C27.7943 9.22406 27.2778 9.18405 26.9347 9.47803C26.5915 9.77193 26.5515 10.2884 26.8454 10.6316C26.8729 10.6637 26.9026 10.6934 26.9347 10.7208L33.7172 17.5117H1.32595C0.874134 17.5117 0.507812 17.878 0.507812 18.3299C0.507812 18.7818 0.874134 19.148 1.32595 19.148H33.7172L26.9347 25.9306C26.5915 26.2245 26.5515 26.741 26.8454 27.0842C27.1394 27.4274 27.6558 27.4674 27.999 27.1734C28.0311 27.1459 28.0608 27.1162 28.0882 27.0842L36.2699 18.9025C36.5871 18.5835 36.5871 18.0681 36.2699 17.749Z"
                        fill="#F4F2F0"
                     />
                  </g>
                  <defs>
                     <clippath id="clip0_5116_214025">
                        <rect
                           width="36"
                           height="36"
                           fill="white"
                           transform="translate(0.507812 0.324219)"
                        />
                     </clippath>
                  </defs>
               </svg>
            </Link>
         </div>
      </section>
   )
}
